<div class="card">
    <div class="card-header">
        <h3>Posiciones finales</h3>
        <div class="group-actions" *ngIf="esAdmin$ | async">
            <a (click)="resolveClassification()">Resolver clasificación</a>
        </div>
    </div>
    <div class="player-list" *ngIf="playersGroup">
        <div class="player" *ngFor="let p of playersGroup">
            <div class="player-avatar">{{p.player?.playerLabel}}</div>
            <div class="player-name">{{p.player?.playerName}}</div>
            <div class="player-order">{{p.order}}</div>
            <div class="games-played">
                <div class="result-title" title="Partidos jugados">PJ</div>
                <div class="value">{{p.matchesPlayed ?? 0}}</div>
            </div>
            <div class="games-result">
                <div class="result-title" title="Partidos ganados - perdidos">PG - PP</div>
                <div class="value">{{p.matchesWon ?? 0}} - {{p.matchesLost ?? 0}} <span class="dif">({{(p.matchesWon ?? 0) - (p.matchesLost ?? 0)}})</span></div>
            </div>
            <div class="set-result">
                <div class="result-title" title="Games ganados - perdidos">GG - GP</div>
                <div class="value">{{p.setsWon ?? 0}} - {{p.setsLost ?? 0}} <span class="dif">({{(p.setsWon ?? 0) - (p.setsLost ?? 0)}})</span></div>
            </div>
            <div class="points-result">
                <div class="result-title" title="Puntos ganados - perdidos">Pt.G - Pt.P</div>
                <div class="value">{{p.pointsWon ?? 0}} - {{p.pointsLost ?? 0}} <span class="dif">({{(p.pointsWon ?? 0) - (p.pointsLost ?? 0)}})</span></div>
            </div>
        </div>
    </div>
</div>